
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import NoneAddedPopup from '../NoneAddedPopup';
import Table from '../Table';
import Add from './AddDecision';
import { addDecision, deleteDecision, updateDecision } from '../../../../../reducers/JsonRuleEditor/RulesActions';

const headings = {
    id: "id",
    Outcome: "Outcome",
    conditionDisplay: 'Condition'
};

export default function Decision() {
    const [view, setView] = useState("list");
    const [searchText, setSearchText] = useState("");
    const dispatch = useDispatch();
    const currentRule = useSelector(state => state.JsonRulesEditorReducer.currentRule);
    const decisions = currentRule.decisions || [];
    const [displayDecisions, setDisplayDecisions] = useState(decisions);
    const [editingDecision, setEditingDecision] = useState(null);
    const facts = currentRule.facts || [];

    const handleSearch = () => {
        if (searchText === "") {
            setDisplayDecisions(decisions);
        } else {
            const filtered = decisions.filter((el) =>
                el.Outcome?.toLowerCase().includes(searchText.toLowerCase())
            );
            setDisplayDecisions(filtered);
        }
    };

    const handleView = (type) => {
        setView(type);
    };

    const handleViewFn = (type, data) => {
        if (type === "delete") {
            dispatch(deleteDecision(data.id));
        } else if (type === "edit") {
            setEditingDecision(data);
            setView("edit");
        }
    };

    const handleAddDecision = (decisionData) => {
        dispatch(addDecision(decisionData));
        setView("list");
    };

    return (
        <>
            {view === "list" ? (
                <div style={{ marginTop: '30px' }}>
                    <div className="row">
                        <div className="col-sm-2 col-xs-12">
                            <input
                                type='text'
                                className='form-control'
                                onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                                value={searchText}
                                onChange={(e) => {
                                    setSearchText(e.target.value);
                                    if (e.target.value === '') handleSearch();
                                }}
                                placeholder='Type here...'
                            />
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <button
                                className='addbtn'
                                onClick={() => handleView("add")}
                            >
                                <i className="fa fa-plus" aria-hidden="true"></i>&nbsp;Add Decision
                            </button>
                        </div>
                    </div>
                    <hr />
                    <div>
                        {decisions && decisions.length > 0 ? (
                            <Table
                                headingsObj={headings}
                                DataArray={decisions}
                                includeView={false}
                                includeDelete={true}
                                includeEdit={true}
                                handleViewFn={handleViewFn}
                            />
                        ) : (
                            <NoneAddedPopup
                                heading={"No Decisions"}
                                text={"There are no decisions available in the selected ruleset."}
                                buttonText={"Create Decisions"}
                                buttonFn={handleView}
                            />
                        )}
                    </div>
                </div>
            ) : ''}

            {view === "add" ? (
                <Add
                    facts={facts}
                    onSave={handleAddDecision}  // Use handleAddDecision for adding new decisions
                    onCancel={() => setView("list")}
                    initialData={null}  // Pass null for new decisions
                />
            ) : ''}

            {view === "edit" ? (
                <Add
                    facts={facts}
                    onSave={(updatedDecision) => {
                        dispatch(updateDecision({ ...updatedDecision, id: editingDecision.id }));
                        setEditingDecision(null);
                        setView("list");
                    }}
                    onCancel={() => {
                        setEditingDecision(null);
                        setView("list");
                    }}
                    initialData={editingDecision}
                />
            ) : ''}
        </>
    );
}